import { Autocomplete, TextField } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AllEnums, EnumListKey } from '~/data/enums';
import { Form } from '~/features/RehireDialog/hooks/useRehireEmpForm';
import { useRehireEnumFilteredOptions } from '~/features/RehireDialog/hooks/useRehireEnumFilteredOptions';
import { useSxStyles } from '~/features/RehireDialog/useStyles';

type Props = {
  control: Control<Form>;
  allEnums: AllEnums;
  disabled?: boolean;
};

export const EmploymentStatusComponent = ({
  control,
  allEnums,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const requiredText = t('fieldIsRequired');

  const filteredOptions = useRehireEnumFilteredOptions(
    control,
    allEnums,
    EnumListKey.EMPLOYMENT_STATUS,
  );

  return (
    <Controller
      control={control}
      name={'rehire.employmentDetails.fEmplDetailStatus'}
      rules={{ required: requiredText }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          options={filteredOptions}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          onChange={(_, value) => onChange(value?.code || '')}
          value={filteredOptions.find((o) => o?.code === value) || null}
          sx={{ ...sxStyles.selectStyle, ...sxStyles.inputBottomMargin }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              label={t('laEmploymentStatus')}
              error={!!error}
              helperText={error?.message}
            />
          )}
          disabled={disabled}
        />
      )}
    />
  );
};
